const BENEFICIARIES_LIST = 'bfb/project/BENEFICIARIES_LIST';
const BENEFICIARIES_LIST_SUCCEEDED = 'bfb/project/BENEFICIARIES_LIST_SUCCEEDED';
const BENEFICIARIES_LIST_FAILED = 'bfb/project/BENEFICIARIES_LIST_FAILED';

export default {
  BENEFICIARIES_LIST,
  BENEFICIARIES_LIST_SUCCEEDED,
  BENEFICIARIES_LIST_FAILED,
};
